import React from 'react';
import { useKioskStore } from '@/store/kiosk-store';
import { selectCurrentScreen } from '@/store/selectors';
import { useAuth } from '@/hooks/use-auth';
import { useHeartbeat } from '@/hooks/use-heartbeat';
import { useConfig } from '@/hooks/use-config';
import AttractScreen from '@/screens/AttractScreen';
import ModuleSelector from '@/screens/ModuleSelector';
import ProvisioningScreen from '@/screens/ProvisioningScreen';

/**
 * Root shell that activates background hooks and switches between screens
 * based on the current Zustand state. No React Router — pure state machine.
 */
const KioskShell: React.FC = () => {
  useAuth();
  useHeartbeat();
  useConfig();

  const screen = useKioskStore(selectCurrentScreen);

  switch (screen) {
    case 'provisioning':
      return <ProvisioningScreen />;
    case 'attract':
      return <AttractScreen />;
    case 'selector':
      return <ModuleSelector />;
    default:
      return <AttractScreen />;
  }
};

export default KioskShell;
